module.exports = __webpack_public_path__ + "static/media/annette_avatar.0ed7095a.png";